import { AddOnsTemplate } from '@/components/add-ons/template';
import { GalleriesItem } from '@/components/galleries/item';
import { GalleriesList } from '@/components/galleries/list';
import { ComponentsHead } from '@/components/head';
import { StaticImage } from 'gatsby-plugin-image';
import { FC } from 'react';
import { SwiperSlide } from 'swiper/react';

export const BEER_CAN_ISLAND_TITLE = 'Beer Can Island';

export const Head = () => {
  return (
    <ComponentsHead
      title=""
      description=""
      keywords=""
    />
  );
};

const DestinationsBeerCanIsland: FC = () => {
  return (
    <AddOnsTemplate
      title="Boat to  (Pine Key) — Tampa Bay’s Floating Party Paradise"
      subtitle={BEER_CAN_ISLAND_TITLE}
    >
      <GalleriesList>
        <SwiperSlide>
          <GalleriesItem>
            <StaticImage
              alt={`${BEER_CAN_ISLAND_TITLE} header`}
              src="../../images/destinations/beer-can-island/0.jpg"
            />
          </GalleriesItem>
        </SwiperSlide>
        <SwiperSlide>
          <GalleriesItem>
            <StaticImage
              alt={`${BEER_CAN_ISLAND_TITLE} slide 1`}
              src="../../images/destinations/beer-can-island/1.jpg"
            />
          </GalleriesItem>
        </SwiperSlide>
        <SwiperSlide>
          <GalleriesItem>
            <StaticImage
              alt={`${BEER_CAN_ISLAND_TITLE} slide 2`}
              src="../../images/destinations/beer-can-island/2.jpg"
            />
          </GalleriesItem>
        </SwiperSlide>
      </GalleriesList>
    </AddOnsTemplate>
  );
};

export default DestinationsBeerCanIsland;
